import {toInt} from '@/library/math';
import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const CustomerInvoiceDebitEdit = () => import('@/views/customer/invoice/debit/CustomerInvoiceDebitEdit.vue');
const CustomerInvoiceDebitList = () => import('@/views/customer/invoice/debit/CustomerInvoiceDebitList.vue');
const CustomerInvoiceDebitImportList = () => import('@/views/customer/invoice/debit/CustomerInvoiceDebitImportList.vue');
const CustomerInvoiceDebitImportEntryList = () => import('@/views/customer/invoice/debit/CustomerInvoiceDebitImportEntryList.vue');
const CustomerInvoiceArchive = () => import('@/views/customer/CustomerInvoiceArchive.vue');
const CustomerInvoice        = () => import('@/views/customer/CustomerInvoice.vue');
const CustomerInvoiceDunningList = () => import('@/views/customer/invoice/dunning/CustomerInvoiceDunningList.vue');
const CustomerInvoiceDunningTemplateList = () => import('@/views/customer/invoice/dunning/CustomerInvoiceDunningTemplateList.vue');
const CustomerInvoiceDunningTemplateEdit = () => import('@/views/customer/invoice/dunning/CustomerInvoiceDunningTemplateEdit.vue');
const CustomerInvoiceOverpaidList = () => import('@/views/customer/invoice/CustomerInvoiceOverpaidList.vue');

const meta: MetaData = {
    module: 'customer',
};

let routes: RouteRecordRaw[] = [
    {
        name: 'customer-invoice-archive',
        path: '/customer/invoice/archive',
        meta,
        component: CustomerInvoiceArchive,
    },
    {
        name: 'customer-invoice',
        path: '/customer/invoice/generate-list',
        meta,
        component: CustomerInvoice,
    },
    {
        name: 'customer-invoice-debit-list',
        path: '/customer/invoice/debit',
        meta,
        component: CustomerInvoiceDebitList,
    },
    {
        name: 'customer-invoice-debit-list-done',
        path: '/customer/invoice/debit/done',
        meta,
        component: CustomerInvoiceDebitList,
        props()
        {
            return {
                type: 'done',
            };
        },
    },
    {
        name: 'customer-invoice-debit-import-list',
        path: '/customer/invoice/debit/import',
        meta,
        component: CustomerInvoiceDebitImportList,
    },
    {
        name: 'customer-invoice-debit-import-entry-list',
        path: '/customer/invoice/debit/import/:id(\\d+)',
        meta,
        component: CustomerInvoiceDebitImportEntryList,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },
    {
        name: 'customer-invoice-debit-overpaid',
        path: '/customer/invoice/overpaid',
        meta,
        component: CustomerInvoiceOverpaidList,
    },
    //<editor-fold desc="debit">
    {
        name: 'customer-invoice-debit-add',
        path: '/customer/invoice/debit-add',
        meta,
        component: CustomerInvoiceDebitEdit,
        props()
        {
            return {
                id: 0,
            };
        },
    },
    {
        name: 'customer-invoice-debit-edit',
        path: '/customer/invoice/debit-edit/:id',
        meta,
        component: CustomerInvoiceDebitEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },
    //</editor-fold>
    //<editor-fold desc="dunning">
    {
        name: 'customer-invoice-dunning-list',
        path: '/customer/invoice/dunning-list/:state?',
        meta,
        component: CustomerInvoiceDunningList,
        props(route: RouteLocationStringParam)
        {
            return {
                state: route.params.state || 'open',
            };
        },
    },
    {
        name: 'customer-invoice-dunning-template-list',
        path: '/customer/invoice/dunning-template',
        meta,
        component: CustomerInvoiceDunningTemplateList,
    },
    {
        name: 'customer-invoice-dunning-template-add',
        path: '/customer/invoice/dunning-template-add',
        meta,
        component: CustomerInvoiceDunningTemplateEdit,
    },
    {
        name: 'customer-invoice-dunning-template-edit',
        path: '/customer/invoice/dunning-template-edit/:id',
        component: CustomerInvoiceDunningTemplateEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },
    //</editor-fold>
    {
        path: '/customer/invoice/:wildcard*',
        redirect: {name: 'customer-index'},
    },
];

export default routes;
